import { LegalLayout } from '../components/legal/LegalLayout';

export default function TermsOfService() {
  const sections = [
    {
      heading: 'Acceptance of Terms',
      body: [
        'By accessing or using the Dr. Angelia Griffin Grief Coaching website, or by enrolling in any of our programs, workshops, courses, or services (collectively, the "Services"), you agree to be bound by these Terms of Service. If you do not agree, please do not use the Services.',
      ],
    },
    {
      heading: 'About Our Services',
      body: [
        'We provide educational grief programs built on the M.O.V.E.™ Course System, including introductory workshops, self-paced courses, live workshop series, intensives, and cohort experiences. Our programs are designed to educate and support adults navigating loss.',
      ],
    },
    {
      heading: 'Not Therapy or Medical Care',
      body: [
        'Grief coaching and our educational programs are NOT therapy, counseling, psychological treatment, medical care, or crisis intervention, and are not a substitute for professional mental health services. Dr. Griffin is a grief coach and educator. If you are experiencing a mental health crisis or emergency, please contact a licensed mental health professional or call or text the 988 Suicide & Crisis Lifeline immediately.',
      ],
    },
    {
      heading: 'Eligibility',
      body: [
        'You must be at least 18 years old to enroll in and use our Services. By using the Services, you represent that you meet this requirement and that the information you provide is accurate and complete.',
      ],
    },
    {
      heading: 'Enrollment, Payment & Refunds',
      body: [
        'Program fees, session details, and any payment plan options are described at the point of enrollment. Payments are processed through our authorized third-party providers. Access to a program begins upon successful payment and enrollment. Refund eligibility, if any, will be described in the specific program terms at the time of purchase; digital and completed live services may be non-refundable.',
      ],
    },
    {
      heading: 'Intellectual Property',
      body: [
        'All content, materials, curricula, videos, workbooks, frameworks, and the M.O.V.E.™ Course System are the intellectual property of Dr. Angelia Griffin and AGC LLC, and are protected by applicable intellectual property laws. You are granted a limited, personal, non-transferable license to access and use program materials for your own individual use. You may not reproduce, distribute, resell, or share program content without prior written permission.',
      ],
    },
    {
      heading: 'Your Responsibilities',
      body: ['When using the Services, you agree that you will not:'],
      items: [
        'Share your account or program access with others.',
        'Copy, record, distribute, or resell program materials or live session content.',
        'Use the Services for any unlawful, harmful, or abusive purpose.',
        'Interfere with the operation or security of our website or platforms.',
      ],
    },
    {
      heading: 'Third-Party Services & Links',
      body: [
        'Our Services may integrate with or link to third-party platforms, assessments, payment processors, and websites that we do not control. We are not responsible for the content, policies, or practices of these third parties, and your use of them is subject to their own terms.',
      ],
    },
    {
      heading: 'Disclaimers',
      body: [
        'The Services are provided on an "as is" and "as available" basis. While we strive to deliver meaningful, high-quality educational experiences, we make no guarantees regarding specific outcomes or results. Grief is personal and non-linear, and individual experiences will vary.',
      ],
    },
    {
      heading: 'Limitation of Liability',
      body: [
        'To the fullest extent permitted by law, Dr. Angelia Griffin, AGC LLC, IGMA, Inc., and their affiliates shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of, or inability to use, the Services.',
      ],
    },
    {
      heading: 'Governing Law',
      body: [
        'These Terms are governed by the laws of the State of Georgia, United States, without regard to its conflict of law principles. Any disputes shall be resolved in the courts located in Georgia.',
      ],
    },
    {
      heading: 'Changes to These Terms',
      body: [
        'We may update these Terms of Service from time to time. Updates will be posted on this page with a revised "Last updated" date. Your continued use of the Services after changes are posted constitutes acceptance of the updated Terms.',
      ],
    },
    {
      heading: 'Contact Us',
      body: [
        'If you have questions about these Terms of Service, please contact us at info@agcthefixer.com or (770) 422-4048.',
      ],
    },
  ];

  return (
    <LegalLayout
      testId="terms-of-service-page"
      title="Terms of Service"
      lastUpdated="December 2025"
      intro="Please read these Terms of Service carefully before using the Dr. Angelia Griffin Grief Coaching website and programs. These Terms govern your access to and use of our educational Services."
      sections={sections}
    />
  );
}
